export const GET_BILLER_DETAILS_STARTED = "GET_BILLER_DETAILS_STARTED";
export const GET_BILLER_DETAILS_SUCCEDEED = "GET_BILLER_DETAILS_SUCCEDEED";
export const GET_BILLER_DETAILS_FAILED = "GET_BILLER_DETAILS_FAILED";
export const PAY_TV_BILLS_STARTED = "PAY_TV_BILLS_STARTED";
export const PAY_TV_BILLS_SUCCEEDED = "PAY_TV_BILLS_SUCCEEDED";
export const PAY_TV_BILLS_FAILED = "PAY_TV_BILLS_FAILED";
export const SET_TV_BILLER = "SET_TV_BILLER";
export const SET_PACKAGE_BILLER = "SET_PACKAGE_BILLER";
export const GET_BILLERS_STARTED = "GET_BILLERS_STARTED";
export const GET_BILLERS_SUCCEEDED = "GET_BILLERS_SUCCEEDED";
export const GET_BILLERS_FAILED = "GET_BILLERS_FAILED";
export const RESET_TV = "RESET_TV";
export const INITIATE_BILL_PAYMENT_STARTED = "INITIATE_BILL_PAYMENT_STARTED";
export const INITIATE_BILL_PAYMENT_SUCCEDEED =
  "INITIATE_BILL_PAYMENT_SUCCEDEED";
export const INITIATE_BILL_PAYMENT_FAILED = "INITIATE_BILL_PAYMENT_FAILED";
export const GET_BILLERS_LIST_SUCCEEDED = "GET_BILLERS_LIST_SUCCEEDED"